import {inject, Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Matricula} from '@kilobytelab/types';
import {API_URL_TOKEN} from '../token';

@Injectable({
  providedIn: 'root'
})
export class ApiMatService {

  private http = inject(HttpClient);
  private apiUrl = inject(API_URL_TOKEN);

  /*** matriculas ***/

  crearCopiaMatricula(id: number): Promise<string> {
    const url = `${this.apiUrl}matriculas/enviarcopia/${id}`;
    return firstValueFrom(this.http.get<string>(url))
  }
  enviarCopiaMatriculaExistente(id: number): Promise<any> {
    const url = `${this.apiUrl}matriculas/enviarcopiaexistente/${id}`;
    return firstValueFrom(this.http.get<any>(url))
  }
  getMatricula(id: number): Promise<Matricula> {
    const url = `${this.apiUrl}matriculas/${id}`;
    return firstValueFrom(this.http.get<Matricula>(url))
  }
  getMatriculaEnBlanco(id: number): Promise<string> {
    const url = `${this.apiUrl}matriculas/blanco/${id}`;
    return firstValueFrom(this.http.get<string>(url))
  }
  addMatricula(datos: {id: number, RGPD: boolean, marketing: boolean, Fotos: boolean, SEPA: boolean, firma: string}): Promise<any> {
    const url = `${this.apiUrl}matriculas/${datos.id}`;
    return firstValueFrom(this.http.put<any>(url, datos))
  }
  addMatriculaPdf(datos: {id: number, RGPD: boolean, marketing: boolean, Fotos: boolean, SEPA: boolean, matricula: string}): Promise<any> {
    const url = `${this.apiUrl}matriculas/pdf/${datos.id}`;
    return firstValueFrom(this.http.put<any>(url, datos))
  }
  eliminarMatricula(id: number): Promise<any> {
    const url = `${this.apiUrl}matriculas/${id}`;
    return firstValueFrom(this.http.delete<any>(url))
  }

}
